import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { buttonPrimaryStyles, sectionBox } from "../styles/ComponentStyles";
import { confirmPasswordReset } from "../api/userPassword";
import { useTranslate } from "../components/Translate/TranslateContext";

export default function ResetPassword() {
  const { translate } = useTranslate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const token = window.location.hash.replace("#", "");


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirm) {
      setStatusMessage(translate("password_error"));
      return;
    }
    if (password !== confirm) {
      setStatusMessage(translate("passwords_do_not_match"));
      return;
    }

    try {
      setLoading(true);
      const res = await confirmPasswordReset(token, password);
      if (res.success) {
        setStatusMessage(translate("password_reset_success"));
        // refresh + redirect after short delay
        setTimeout(() => {
          window.location.href = "/";
        }, 2500);
      } else {
        setStatusMessage(translate("password_reset_failed"));
      }
    } catch (err) {
      setStatusMessage(translate("server_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        ...sectionBox,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: "calc(100vh - 70px)", 
      }}
    >
      <Card sx={{ maxWidth: 400, width: "90%", textAlign: "center", boxShadow: 6 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img
              src="/tensoLogo.jpg"
              alt="TensoAI Logo"
              style={{
                width: "64px",
                height: "64px",
                objectFit: "contain",
              }}
            />
          </Box>

          <Typography variant="h5" gutterBottom>
            {translate("reset_password")}
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              label={translate("new_password")}
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              label={translate("confirm_password")}
              type="password"
              fullWidth
              margin="normal"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />

            {statusMessage && (
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  color:
                    statusMessage === translate("password_reset_success")
                      ? "green"
                      : "red",
                  fontWeight: 500,
                }}
              >
                {statusMessage}
              </Typography>
            )}

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{ ...buttonPrimaryStyles, mt: 2 }}
            >
              {loading
                ? translate("confirm_reset")
                : translate("confirm_reset")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
